import { destroy } from '@alltrails/core/utils/destroy';
import type { WaypointId } from '@alltrails/types/Waypoint';

export function deleteWaypoint(atMapId: number, waypointId: WaypointId) {
  return destroy<{ meta: { status: string } }>(`/api/alltrails/maps/${atMapId}/waypoints/${waypointId}`);
}

export function deleteAllWaypoints(atMapId: number) {
  return destroy<{ meta: { status: string } }>(`/api/alltrails/maps/${atMapId}/waypoints/all`);
}
